import { throttle } from 'lodash-es';
import getScrollPosition from '../utils/getScrollPosition';
import MediaQuery from '../lib/MediaQuery';

export default function v1HeaderFixed() {
  const body = document.getElementsByTagName('body')[0];
  const headerBodyElm = document.getElementById('v1-header__body');
  const headerHeadElm = document.getElementById('v1-header__head');
  const headerInfoElm = document.getElementById('v1-header__info');
  const fixedClass = '-fixed';
  if (!headerBodyElm) return;
  let headerHeadHeight = headerInfoElm
    ? headerHeadElm.clientHeight + headerInfoElm.clientHeight
    : headerHeadElm.clientHeight;
  let headerBodyHeight = headerBodyElm.clientHeight;// eslint-disable-line

  window.addEventListener(
    'resize',
    throttle(() => {
      headerHeadHeight = headerInfoElm
        ? headerHeadElm.clientHeight + headerInfoElm.clientHeight
        : headerHeadElm.clientHeight;
      headerBodyHeight = headerBodyElm.clientHeight;
    }, 1000 / 60),
  );

  /**
   * スマホのナビゲーションを上部固定する。
   * @param {Number} pageYOffset ページ上部のスクロール数
   * @param {Number} elmTop 固定する要素の上部位置を前の兄弟要素で擬似的に取得する
   */
  function toggleFixed(pageYOffset, elmTop) {
    const canFixed = pageYOffset > elmTop;
    const hasFixed = headerBodyElm.classList.contains(fixedClass);

    MediaQuery.matches('xs', matches => {
      if (matches) {
        // 固定できる & 固定されていない
        if (canFixed && !hasFixed) {
          headerBodyElm.classList.add(fixedClass);
          body.style.paddingTop = `${headerBodyHeight}px`;
        }

        // 固定できない & 固定されている
        if (!canFixed && hasFixed) {
          headerBodyElm.classList.remove(fixedClass);
          body.style.paddingTop = '0';
        }
      }
    });

    MediaQuery.matches('lg', matches => {
      if (matches) {
        headerBodyElm.classList.remove(fixedClass);
        body.style.paddingTop = '';
      }
    });
  }

  function fixedInit() {
    const pageYOffset = getScrollPosition().y;

    MediaQuery.matches('lg', matches => {
      if (!matches) {
        toggleFixed(pageYOffset, headerHeadHeight);
      }
      if (matches) {
        body.style.paddingTop = '';
      }
    });
  }

  window.addEventListener('load', () => {
    fixedInit();
  });

  window.addEventListener(
    'scroll',
    throttle(() => {
      fixedInit();
    }, 1000 / 60),
  );

  window.addEventListener(
    'resize',
    throttle(() => {
      fixedInit();
    }, 1000 / 60),
  );
}
